export default __webpack_public_path__ + "static/media/gold_star_with_points.cd369a2e.png";